export const moduleName = 'modals';
